import { useClipboard as useChakraClipboard } from "@chakra-ui/react";

export function useClipboard(text: string, timeout = 1500) {
  // Chakra v3 useClipboard requires `value` in options
  const { copy, copied } = useChakraClipboard({ value: text, timeout });

  return {
    value: text,
    onCopy: copy,
    hasCopied: copied,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setValue: () => {}, // Not used in v3
  };
}
